import { makeStyles } from '@rbx/ui';

const useMarkdownAlertStyles = makeStyles()((theme) => ({
  alertContainer: {
    maxWidth: '100%',
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(3),
    fontSize: 16,
    '& .MuiAlert-icon': {
      marginTop: 1.5,
    },
  },

  innerContainer: {
    '& .MuiTypography-paragraph:last-child': {
      // This exists to ensure that there is no excessive spacing
      // below paragraph tags inside of alerts.
      marginBottom: 0,
    },
    // prevent the alert text from having secondary text color applied from MarkdownP
    '& p, & ul, & ol': {
      color: 'inherit',
      fontSize: 'inherit',
    },
  },
}));

export default useMarkdownAlertStyles;
